import React, { useCallback, useMemo, useState } from 'react';
import OolaButton from '../Dashboard/Tracker/OolaButton';
import DailyActions from '../Dashboard/Tracker/DailyActions/DailyActions';
import ToDoList from '../Dashboard/Tracker/ToDoList/ToDoList';
import { demoDashboardState } from './marketingDemoData';
import '../Dashboard/Tracker/Tracker.css';

const MARKETING_GLOBAL_STEPS = 2847391;

/**
 * Production Tracker UI with fictional Jordan Rivera data — marketing only.
 * No API calls; uses real OolaButton + DailyActions components.
 */
const MarketingProductionTracker = ({ initialTab = 'daily' }) => {
    const [allState, setAllState] = useState(() => ({
        ...demoDashboardState,
        userProgress: { ...demoDashboardState.userProgress },
        Actions: demoDashboardState.Actions.map((action) => ({ ...action })),
    }));
    const [currentTrackerTab, setCurrentTrackerTab] = useState(
        initialTab === 'tracker' ? 0 : 1
    );
    const [show, setShow] = useState(false);
    const [saving] = useState(false);

    const allStateChange = useCallback((next) => {
        setAllState(typeof next === 'function' ? next : { ...next });
    }, []);

    const noop = useCallback(() => {}, []);

    const marketingPreview = useMemo(
        () => ({ globalStepsTaken: MARKETING_GLOBAL_STEPS }),
        []
    );

    return (
        <article className="tracker marketing-production-tracker">
            <div className="TitleDashboardContent">
                <p className="heading-5 BlueDarkText">MY ACTION TRACKER</p>
            </div>

            <ul className="myActionTrackerTabsContainer TitleMyGoal">
                <li>
                    <button
                        type="button"
                        className={` firstTabMyGoal ${
                            currentTrackerTab === 0 ? 'activeTabTacker' : ''
                        }`}
                        onClick={() => setCurrentTrackerTab(0)}
                    >
                        TRACKER
                    </button>
                </li>
                <li>
                    <button
                        type="button"
                        className={`${
                            currentTrackerTab === 1 ? 'activeTabTacker' : ''
                        }`}
                        onClick={() => setCurrentTrackerTab(1)}
                    >
                        DAILY ACTIONS
                    </button>
                </li>
                <li>
                    <button type="button">TO-DO LIST</button>
                </li>
            </ul>

            <section className="MyTrackerSection__Container">
                {currentTrackerTab === 0 && (
                    <div className="tracker__container">
                        <OolaButton
                            AllState={allState}
                            setShowModalFromButton={noop}
                            setShowModal={noop}
                            saving={saving}
                            marketingPreview={marketingPreview}
                        />
                    </div>
                )}

                {currentTrackerTab === 1 && (
                    <DailyActions
                        show={show}
                        setShowModal={setShow}
                        AllState={allState}
                        AllStateChange={allStateChange}
                        SaveActionStepsChange={noop}
                        setShowModalFromButton={noop}
                        setSaving={noop}
                        setCurrentTrackerTab={setCurrentTrackerTab}
                        getMyProgress={noop}
                        getCurrentDailyActions={noop}
                        saving={saving}
                        marketingPreview
                    />
                )}

                {currentTrackerTab === 2 && <ToDoList />}
            </section>
        </article>
    );
};

export default MarketingProductionTracker;
